(function() {
    function getChatbotConfig(clientConfig) {

        const pageConfig = window.c24LpChatbotConfig;
        if (!pageConfig) {
            return undefined;
        }

        const pageClientConfig = pageConfig.chatbot.client;
        const env = window.c24LpIsProduction ? 'prod' : 'test';
        const controlServerAddress = env === 'prod'
            ? 'https://api.chat.check24.de'
            : 'https://api.chat.check24-test.de';

        if (!clientConfig) {
            clientConfig = {
                chatFlowName: pageClientConfig.chatFlowName,
                chatFlowEntry: pageClientConfig.chatFlowEntry,
            };
        }

        if (!clientConfig.clientDetails) {
            clientConfig.clientDetails = pageClientConfig.clientDetails;
        }

        return {
            chattyVersion: pageConfig.chattyVersion,
            env: env,
            onDemand: true,
            type: 'chatty',
            name: 'chatty'
                + '-' + clientConfig.chatFlowName
                + '-' + clientConfig.chatFlowEntry,
            deviceoutput: window.c24LpDeviceOutput,
            chatbot: {
                client: {
                    controlServerAddress: controlServerAddress,
                    chatFlowRelease: 'active',
                    ...clientConfig,
                },
                env: env,
                deviceoutput: window.c24LpDeviceOutput,
                forceNewSession: false,
            },
        };
    }

    window.c24LpOpenChatbot = function(clientConfig) {

        const config = getChatbotConfig(clientConfig);
        if (!config) {
            return;
        }

        window.c24LpFrameJsReady.then(function() {

            if (window.c24LpIsApp) {
                window.Check24.loader.useChatbotApp = true;
            }

            window.Check24.loader.openChatbot(config);
        });
    };

    window.c24LpAddChatbotElement = function(clientConfig, element) {

        const config = getChatbotConfig(clientConfig);
        if (!config) {
            return;
        }

        window.c24LpFrameJsReady.then(function() {

            if (window.c24LpIsApp) {
                window.Check24.loader.useChatbotApp = true;
            }

            window.Check24.loader.addChatbotElement(config, element);
        });
    };

    window.c24DomReady(function() {

        const chatbotLinks = document.querySelectorAll('.chatbot-link');
        chatbotLinks.forEach(function(link) {

            const flowName = link.getAttribute('data-chatbot-flow-name');
            const flowEntry = link.getAttribute('data-chatbot-flow-entry');

            link.addEventListener('click', function(event) {
                event.preventDefault();
                window.c24LpOpenChatbot({
                    chatFlowName: flowName,
                    chatFlowEntry: flowEntry,
                });
            });
        });

        window.c24LpFrameJsReady.then(function() {

            const pageConfig = window.c24LpChatbotConfig;
            if (!pageConfig) {
                return;
            }

            const config = getChatbotConfig();
            if (!config) {
                return;
            }

            if (window.c24LpIsApp) {
                window.Check24.loader.useChatbotApp = true;
                window.C24App?.setSupportDialogHandler(
                    () => { window.Check24.loader.openChatbot(config); return true; },
                );
            }

            if (window.c24LpIsMobile) {
                window.Check24.tapBar.init(config);
            }

            config.contact = {
                layer: pageConfig?.contact?.layer,
                button: pageConfig?.contact?.button,
            };

            if (config.contact.layer !== undefined) {
                window.Check24.loader.setContactLayer(config, true);
            }

            if (!window.c24LpIsMobile && config?.contact?.button !== undefined) {
                window.Check24.loader.addChatbotButton(config, true);
            }
        });
    });
})();

